<template>
  <div class="alarm-level-tab">
    <b-row class="alarm-level-tab__header">
      <b-col class="alarm-level-tab__col" cols="1">
        <span class="alarm-level-tab__gas-name">
          {{$t('engineering.chromatography.alarm-levels-parameters.gas') }}
        </span>
      </b-col>
      <b-col
        v-for="item in alarmLevel.header"
        class="alarm-level-tab__col alarm-level-tab__color-table"
        :key="item.name"
      >
        <span class="alarm-level-tab__title">
          {{$t(item.name) }}
        </span>
      </b-col>
    </b-row>
    <b-row class="alarm-level-tab__table">
      <b-col class="alarm-level-tab__content" cols="1">
        <b-row
          v-for="alarm in alarmLevel.gases"
          class="alarm-level-tab__item"
          :key="alarm.gas"
        >
          <span class="alarm-level-tab__gas-name">
            {{ alarm.gas }}
          </span>
        </b-row>
      </b-col>
      <b-col
        v-for="alarmLevel in orderedColumns"
        class="alarm-level-tab__content"
        :key="alarmLevel.id"
      >
        <b-row class="alarm-level-tab__item">
          <s-input-label-edit
            v-model="alarmLevel.h2"
            :editable="editMode"
            :formatted-value="formatNumberValue(alarmLevel.h2)"
          >
            <s-number-input
              v-model="alarmLevel.h2"
              :numeric-options="inputNumericOptions"
            />
          </s-input-label-edit>
        </b-row>
        <b-row class="alarm-level-tab__item">
          <s-input-label-edit
            v-model="alarmLevel.cH4"
            :editable="editMode"
            :formatted-value="formatNumberValue(alarmLevel.cH4)"
          >
            <s-number-input
              v-model="alarmLevel.cH4"
              :numeric-options="inputNumericOptions"
            />
          </s-input-label-edit>
        </b-row>
        <b-row class="alarm-level-tab__item">
          <s-input-label-edit
            v-model="alarmLevel.c2H6"
            :editable="editMode"
            :formatted-value="formatNumberValue(alarmLevel.c2H6)"
          >
            <s-number-input
              v-model="alarmLevel.c2H6"
              :numeric-options="inputNumericOptions"
            />
          </s-input-label-edit>
        </b-row>
        <b-row class="alarm-level-tab__item">
          <s-input-label-edit
            v-model="alarmLevel.c2H4"
            :editable="editMode"
            :formatted-value="formatNumberValue(alarmLevel.c2H4)"
          >
            <s-number-input
              v-model="alarmLevel.c2H4"
              :numeric-options="inputNumericOptions"
            />
          </s-input-label-edit>
        </b-row>
        <b-row class="alarm-level-tab__item">
          <s-input-label-edit
            v-model="alarmLevel.c2H2"
            :editable="editMode"
            :formatted-value="formatNumberValue(alarmLevel.c2H2)"
          >
            <s-number-input
              v-model="alarmLevel.c2H2"
              :numeric-options="inputNumericOptions"
            />
          </s-input-label-edit>
        </b-row>
        <b-row class="alarm-level-tab__item">
          <s-input-label-edit
            v-model="alarmLevel.co"
            :editable="editMode"
            :formatted-value="formatNumberValue(alarmLevel.co)"
          >
            <s-number-input
              v-model="alarmLevel.co"
              :numeric-options="inputNumericOptions"
            />
          </s-input-label-edit>
        </b-row>
        <b-row class="alarm-level-tab__item">
          <s-input-label-edit
            v-model="alarmLevel.cO2"
            :editable="editMode"
            :formatted-value="formatNumberValue(alarmLevel.cO2)"
          >
            <s-number-input
              v-model="alarmLevel.cO2"
              :numeric-options="inputNumericOptions"
            />
          </s-input-label-edit>
        </b-row>
        <b-row class="alarm-level-tab__item">
          <s-input-label-edit
            v-model="alarmLevel.o2"
            :editable="editMode"
            :formatted-value="formatNumberValue(alarmLevel.o2)"
          >
            <s-number-input
              v-model="alarmLevel.o2"
              :numeric-options="inputNumericOptions"
            />
          </s-input-label-edit>
        </b-row>
        <b-row class="alarm-level-tab__item">
          <s-input-label-edit
            v-model="alarmLevel.n2"
            :editable="editMode"
            :formatted-value="formatNumberValue(alarmLevel.n2)"
          >
            <s-number-input
              v-model="alarmLevel.n2"
              :numeric-options="inputNumericOptions"
            />
          </s-input-label-edit>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    alarmLevel: {
      type: Object,
    },
  },
  computed: {
    orderedColumns() {
      const response = (this.alarmLevel.response || []);
      const header = (this.alarmLevel.header || []);
      return response.sort((firstItem, secondItem) => {
        const headerFirstItem = header.find(
          item => item.alarmLevel === firstItem.alarmLevel
            && item.alarmTypeChromatography === firstItem.alarmTypeChromatography,
        );
        const headerSecondItem = header.find(
          item => item.alarmLevel === secondItem.alarmLevel
            && item.alarmTypeChromatography === secondItem.alarmTypeChromatography,
        );
        return header.indexOf(headerFirstItem) - header.indexOf(headerSecondItem);
      });
    },
    inputNumericOptions() {
      return {
        decimalPlaces: 1,
        minimumValue: 0.0,
        maximumValue: 1000000.0,
      };
    },
  },
  methods: {
    formatNumberValue(value, minimumFractionDigits = 1, maximumFractionDigits = 1) {
      if (typeof value !== 'number') {
        return value;
      }
      return this.$n(value, { minimumFractionDigits, maximumFractionDigits });
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"

.alarm-level-tab
  overflow-x: auto
  padding: 0 15px
  &__content
    padding: 0
  &__header
    min-width: 600px
  &__col
    justify-content: center
    align-items: center
    text-align: center
    display: flex
    height: 52px
    margin: 4px 2px
  &__color-table
    background: var(--color-table-body-accent-bg)
  &__item
    justify-content: center
    align-items: center
    text-align: center
    display: flex
    height: 52px
    margin: 4px 2px
    background-color: var(--color-background-light)
    &:nth-child(2n)
      background: var(--color-table-body-accent-bg)
  &__gas-name
    font-size: 1em
    font-weight: bold
  &__title
    color: var(--color-primary)
    font-size: .80em
    font-weight: bold
    +media-min-sm()
      font-size: 1em
  &__text
    color: var(--font-color-primary)
    font-size: 1em
  &__table
    border: 1px solid var(--color-border-regular)
    box-sizing: border-box
    border-radius: 5px
    min-width: 600px
</style>
